export default __webpack_public_path__ + "static/media/emptycart.edd0d4fa.png";